export default {
	retrived: false,
	loading: true,
	data: {},
	errors: {}
}